import type { HeroFormData } from './types'

export const getHeroGoogleFontHref = (formData: HeroFormData) => {
  const family = formData.sloganCustomFont?.trim()

  if (formData.sloganFontFamily !== 'custom' || !family || !formData.slogan) {
    return undefined
  }

  const variants = [
    formData.sloganCustomFontLight && '0,300',
    formData.sloganCustomFontRegular && '0,400',
    formData.sloganCustomFontBold && '0,700',
    formData.sloganCustomFontLightItalic && '1,300',
    formData.sloganCustomFontRegularItalic && '1,400',
    formData.sloganCustomFontBoldItalic && '1,700',
  ].filter(Boolean)

  if (!variants.length) {
    return undefined
  }

  const familyParam = `${family}:ital,wght@${variants.join(';')}`

  return `https://fonts.googleapis.com/css2?family=${encodeURIComponent(
    familyParam
  )}&display=swap`
}
